/* eslint-disable */

const CatalogDetailFeaturesItem = (props) => {
    const {
        name, preview_picture
    } = props;

    return `
        <div class="catalog-detail-features__item" title="${name}" style="background-image: url('${preview_picture}')">
        </div>
    `;
};

export default CatalogDetailFeaturesItem;
